// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K_LoH{padding:8px 0;font-size:.85rem;line-height:1.2;list-style-type:disc;margin:0;list-style-position:inside}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"includedServices": `K_LoH`
};
export default ___CSS_LOADER_EXPORT___;
